import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import TutorialScene from '@scenes/TutorialScene';
import GameSceneQ2 from '@scenes/GameSceneQ2';
import GameSceneQ3 from '@scenes/GameSceneQ3';
import GameSceneQ4 from '@scenes/GameSceneQ4';
import GameSceneQ5 from '@scenes/GameSceneQ5';
import GameSceneQ6 from '@scenes/GameSceneQ6';
import GameSceneQ7 from '@scenes/GameSceneQ7';
import GameSceneQ8 from '@scenes/GameSceneQ8';
import GameSceneQ9 from '@scenes/GameSceneQ9';
import GameSceneQ10 from '@scenes/GameSceneQ10';
import EndScene from '@scenes/EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'TutorialScene', scene: TutorialScene },
  { key: 'GameSceneQ2', scene: GameSceneQ2 },
  { key: 'GameSceneQ3', scene: GameSceneQ3 },
  { key: 'GameSceneQ4', scene: GameSceneQ4 },
  { key: 'GameSceneQ5', scene: GameSceneQ5 },
  { key: 'GameSceneQ6', scene: GameSceneQ6 },
  { key: 'GameSceneQ7', scene: GameSceneQ7 },
  { key: 'GameSceneQ8', scene: GameSceneQ8 },
  { key: 'GameSceneQ9', scene: GameSceneQ9 },
  { key: 'GameSceneQ10', scene: GameSceneQ10 },
  { key: 'EndScene', scene: EndScene },
];
